import { log } from '@/log'
import { Module } from 'vuex'

// 扱う状態が少ないので1ファイルで定義
// 状態やaction/mutation/gettersが増えるようなら、適宜分割すること
const namespace = 'itemListAutoLoad'

export interface AutoLoadStatus {
  pages: {
    ids: number[]
  }
}
export function initialState(): AutoLoadStatus {
  return {
    pages: {
      ids: [],
    },
  }
}

export function createAutoLoad<RootState>(): Module<AutoLoadStatus, RootState> {
  return {
    namespaced: true,
    state: initialState(),
    mutations: {
      addLaunchId(state, { id }: { id: number }) {
        state.pages.ids.push(id)

        log.debug({ commit: `${namespace}/addLaunchId`, state })
      },
    },
    actions: {
      async launch({ commit, state }): Promise<number> {
        log.debug({ dispatch: `${namespace}/launch`, state })

        const newId = (last(state.pages.ids) || 0) + 1
        commit('addLaunchId', { id: newId })

        return newId
      },
    },
    getters: {
      multiLoadLaunched: state => state.pages.ids.length > 1,
    },
  }
}

function last<T>(xs: T[]): T | undefined {
  return xs[xs.length - 1]
}
